import __request__ from "routing/request";
export function openEvent(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSecurityEventsByIds(ids, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events/byIds", ids, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getFilterOptions(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events/filter_options", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addNotesForEvents(request, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/security_events/notes", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setOwnerForEvents(ids, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/security_events/owner", ids, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function search(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events/search", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function slices(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events/slices", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setStatusForEvents(request, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/security_events/status", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setStatusForInvestigationEvents(request, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/security_events/status/investigation", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInvestigationTeams(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/security_events/teams", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInvestigationUsers(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/security_events/users", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSecurityEvent(eventId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/security_events/${eventId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function upsertEvent(eventId, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/security_events/${eventId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
